<script setup lang="ts" generic="TData, TValue">
import { computed } from 'vue'

import { Header } from '@tanstack/vue-table'

import Button from '../Button/Button.vue'

type Props = {
  header: Header<TData, TValue>
}

const props = defineProps<Props>()

// computed
const sortIcon = computed(() => {
  const isSorted = props.header.column.getIsSorted()
  if (!isSorted) return 'sort'
  else if (isSorted === 'asc') return 'sort-up'
  else return 'sort-down'
})
</script>

<template>
  <div>
    <div
      class="inline-flex cursor-pointer items-center"
      :class="{
        'font-bold': header.column.getIsSorted(),
        'flex-row-reverse':
          header.column.columnDef.meta &&
          'align' in header.column.columnDef.meta
            ? header.column.columnDef.meta.align === 'end'
            : false,
      }"
    >
      <div class="line-clamp-2 select-none">
        <slot></slot>
      </div>
      <Button
        v-if="header.column.getCanSort()"
        class="size-4 cursor-pointer"
        :class="{
          'text-neutral-dark-5/30': !header.column.getIsSorted(),
        }"
        :icon="sortIcon"
      />
    </div>
  </div>
</template>
